<template>
  <div>
     <login @login="login"></login>
     <p class="text-center py-1"><translate>To request the username and password</translate> <router-link :to="{ name: 'Public/Subscribe' }" class="link"><translate>click here</translate></router-link> </p>
     <hr>
     <p class="text-center">
       <small v-translate>Your username and password have been sent to your email address. The possibility and scope of creating reservations and direct sales depend on the contract concluded with SAVANA DOO Skopje. For password recovery, all other questions as well as assistance in using On-Line Booking Software (B2B), call tel. +389 2 3115 826 or e-mail: online@savana.mk</small>
     </p>
  </div>
</template>

<script>
import auth from 'b2b-common/services/auth'
import login from '@/shared/components/login'

import toast from 'b2b-common/mixins/toast'

export default {
  components: { login },
  mixins: [toast],
  methods: {
    login ({ client, username, password }) {
      auth.login({ client, username, password })
        .then(res => {
          if (res) {
            this.addToast({
              message: this.$gettext('Welcome to Savana B2b'),
              title: this.$gettext('Login'),
              variant: 'success'
            })
            this.$router.push({ name: 'Private/Default' })
          } else {
            this.addToast({
              message: this.$gettext('Please check the data entered in the form. Client code, username or password are invalid.'),
              title: this.$gettext('Invalid login'),
              variant: 'danger'
            })
          }
        }).catch(() => {
          this.addToast({
            message: this.$gettext('Invalid form'),
            title: this.$gettext('Invalid login'),
            variant: 'danger'
          })
        })
    }
  }

}
</script>
